/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["plan-features-list{display:block;flex:1 1 auto;text-align:center;width:100%}plan-features-list .mat-list{overflow:hidden;width:100%}plan-features-list .mat-list.dense .mat-list-item{height:38px;font-size:1.5rem}plan-features-list .mat-list.dense .mat-list-item-with-avatar .mat-list-item-content .mat-list-text{padding-left:5px}plan-features-list .mat-list .mat-list-item-content{white-space:nowrap;text-overflow:ellipsis}plan-features-list .mat-list .check-icon{color:#689f38}"];
export { styles as styles };
